import { getSellingPlateform } from "controllers/sellingplateform";
import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";

async function dataStream(callback) {
  const sellpleteform = await getSellingPlateform();
  callback(sortArrayPipe.transform(sellpleteform, 'value'));
}
const PlatformSoldSelect = withBaseSelect([], dataStream);
export default PlatformSoldSelect;
